import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import withUser from '../HOC/HOCwithUser.jsx';
import { Link, Redirect, withRouter } from 'react-router-dom';
import HOCLoader from '../HOC/HOCLoader.jsx';
import MenuButton from '../Menu/MenuButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import AddNewCard from '../Booking/AddNewCard.jsx';
import DeleteAlert from '../Alert/DeleteAlert.jsx';
import { NotificationManager } from 'react-notifications';

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc'
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

class CardListHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const rows = [
            {
                id: 'brand',
                label: this.props.formatMessage({
                    id: 'card.brand'
                })
            },
            {
                id: 'exp_month',
                label: this.props.formatMessage({
                    id: 'card.exp_month'
                })
            },
            {
                id: 'last4',
                label: this.props.formatMessage({
                    id: 'card.last4'
                })
            },
            {
                id: 'exp_year',
                label: this.props.formatMessage({
                    id: 'card.exp_year'
                })
            },
            {
                id: 'action',
                label: this.props.formatMessage({
                    id: 'card.action'
                })
            }
        ];
        const { order, orderBy } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={
                                    row.disablePadding ? 'none' : 'default'
                                }
                                sortDirection={
                                    orderBy === row.id ? order : false
                                }
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={
                                        row.numeric
                                            ? 'bottom-end'
                                            : 'bottom-start'
                                    }
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

CardListHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.secondary.main
    },
    title: {
        flex: '0 0 auto'
    }
});

let CardListToolbar = props => {
    const { numSelected, classes, settings, onAddClick } = props;

    return (
        <div className="d-flex" style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', }}>
            <div className={classes.title + ' ds-boar-title'}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <div className='ds-boar-title'>
                        <h2 style={{
                            textAlign: 'start',
                            // color: '#0078ff',
                            marginTop: 20
                        }}>
                            <FormattedMessage
                                id="card.heading"
                                defaultMessage="Card List"
                            />
                        </h2>
                    </div>
                )}
            </div>
            {/* <div className={classes.spacer} /> */}
            <div className={classes.actions} style={{
                marginTop: -15
            }}>
                {
                    <Tooltip title="Add">
                        <Button
                            variant="fab"
                            color="primary"
                            aria-label="Add"
                            onClick={onAddClick}
                        >
                            <AddIcon />
                        </Button>
                    </Tooltip>
                }
            </div>
        </div>
    );
};

CardListToolbar.propTypes = {
    // classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    mainbalance: PropTypes.number
};

CardListToolbar = withStyles(toolbarStyles)(CardListToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 700
    },
    tableWrapper: {
        overflowX: 'auto'
    }
});
var isMounted = false;
class CardList extends React.Component {
    constructor(props) {
        console.log("newdataaaaaaa", props)
        super();
        this.state = {
            order: 'desc',
            orderBy: 'created_at',
            selected: [],
            data: props.cardList.sources ? props.cardList.sources.data : [],
            page: 0,
            rowsPerPage: 10,
            clickValue: '',
            itemId: '',
            showCreateForm: false,
            deleteAlert: false,
            cardSelected: '',
            taskDataNew: props.location.state !== undefined ? props.location.state.taskData : '',
            booking_dataNew: props.location.state !== undefined ? props.location.state.booking_data : '',
            loginPathProps: props.location.state !== undefined ? props.location.state.loginPath : '',
            taskDataFromConfirmPage: props.location.state !== undefined ? props.location.state.taskDataFromConfirmPage : ''
            
        };
    }

    actionCallbacks(action, res) {
        if (action === 'delete') {
            this.setState({ clickValue: 'delete', itemId: res.key });
        }
    }
    componentDidMount() {
        isMounted = true;
        this.getData();
        console.log("CARD LISTTTTTTTT", this.state.data);
    }
    getData = () => {
        if (isMounted) {
            this.props.cardListAction(this.onCardlistDone);
        }
    };

    onCardlistDone = (success, data) => {

    };

    componentWillUnmount = () => {
        isMounted = false;
    };
    componentDidUpdate(prevProps) {
        if (
            prevProps.cardList.sources.data !== this.props.cardList.sources.data
        ) {
            this.setState({ data: this.props.cardList.sources.data });
        }
    }
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.key) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;
    onAddClick = () => {
        this.setState({ showCreateForm: true });
    };
    redirectToList = () => {
        this.setState({ showCreateForm: false });
        // if(success){
        //     this.props.history.push(`/user/booking_confirm`)
        // }
        // this.props.history.push(`/user/booking_confirm`)
    };
    renderAddForm = () => {
        return (
            <div>
                <AddNewCard
                    getBack={true}
                    redirectToList={this.redirectToList}
                    showManageCards={true}
                />
            </div>
        );
    };

    alertDeleteCard = cardId => {
        this.setState({ deleteAlert: true, cardSelected: cardId });
    };
    handleYes = () => {
        this.setState({ deleteAlert: false });
        this.deleteCard(this.state.cardSelected);
    };
    handleNo = () => {
        this.setState({ deleteAlert: false });
    };
    closeDeleteAlert = () => {
        this.setState({ deleteAlert: false });
    };
    deleteCard = cardId => {
        this.props.deleteCardAction(
            {
                cardToken: cardId
            },
            this.onDeleteDone
        );
    };
    onDeleteDone = (success, data) => {
        if (success) {
            NotificationManager.success(data.message, 'Success');
        }
    };
    render() {
        const { classes } = this.props;
        const {
            data,
            order,
            orderBy,
            selected,
            rowsPerPage,
            page
        } = this.state;
        console.log("stateqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq", data.length)

        if (
            data.length > 0 &&
            this.props.history.location.state &&
            this.props.history.location.state.loginPath === "BookingConfirmPaymentSignIn"
        ) {
            console.log("aaaaaaaaaaaaa", this.props.history.location.taskData);

            this.props.history.push({
                pathname: `/user/booking_confirm`,
                state: {
                    taskData: this.state.taskDataNew,
                    booking_data: this.state.booking_dataNew,
                    loginPath: this.state.loginPathProps,
                    taskDataFromConfirmPage: this.state.taskDataFromConfirmPage,
                    BookingPath: this.props.history.location.state.BookingPath
                }
            });
        }


        const { formatMessage } = this.props.intl;
        const emptyRows =
            rowsPerPage -
            Math.min(rowsPerPage, data.length - page * rowsPerPage);

        if (this.state.clickValue) {
            this.props.history.push({
                pathname: `/address/${this.state.clickValue}`,
                state: { itemId: this.state.itemId }
            });
            // return (
            //     <Redirect
            //         to={{
            //             pathname: `/address/${this.state.clickValue}`,
            //             state: { itemId: this.state.itemId }
            //         }}
            //     />
            // );
        }

        if (this.state.showCreateForm) {
            return this.renderAddForm();
        }
        return (
            <HOCLoader loading={this.props.cardLoader}>
                <div>
                    <CardListToolbar
                        numSelected={selected.length}
                        settings={this.props.settings}
                        onAddClick={this.onAddClick}
                    />
                    <div className="tz-db-table tableWrapper" style={{ marginTop: -10 }}>
                        <Table
                            aria-labelledby="tableTitle"
                            className="table bordered"
                        >
                            <CardListHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                                formatMessage={this.props.intl.formatMessage}
                            />
                            <TableBody>
                                {stableSort(data, getSorting(order, orderBy))
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map(n => {
                                        const isSelected = this.isSelected(
                                            n.key
                                        );
                                        console.log("nnnnnnnnnnnnnn", n);
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.id}
                                                selected={isSelected}
                                            >
                                                <TableCell className="status-cell">
                                                    <div className="badge badge-success">
                                                        {n.brand}
                                                    </div>
                                                </TableCell>
                                                <TableCell scope="row">
                                                    {n.exp_month}
                                                </TableCell>
                                                <TableCell>{n.last4}</TableCell>
                                                <TableCell>
                                                    {n.exp_year}
                                                </TableCell>

                                                <TableCell>
                                                    <MenuButton
                                                        rowData={n}
                                                        items={[
                                                            {
                                                                action:
                                                                    'delete',
                                                                label: formatMessage(
                                                                    {
                                                                        id:
                                                                            'card.delete'
                                                                    }
                                                                )
                                                            }
                                                        ]}
                                                        menuId={'cardMenu'}
                                                        menuCallback={(
                                                            action,
                                                            rowData
                                                        ) =>
                                                            this.alertDeleteCard(
                                                                rowData.id
                                                            )
                                                        }
                                                        iconType={MoreVertIcon}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{ height: 49 * emptyRows }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        className="table-pagination"
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': formatMessage({
                                id: 'pagination.previous'
                            })
                        }}
                        nextIconButtonProps={{
                            'aria-label': formatMessage({
                                id: 'pagination.next'
                            })
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </div>
                <DeleteAlert
                    open={this.state.deleteAlert}
                    close={this.closeDeleteAlert}
                    handleNo={this.handleNo}
                    handleYes={this.handleYes}
                />
            </HOCLoader>
        );
    }
}

CardList.propTypes = {
    // classes: PropTypes.object.isRequired
};
const mapStateToProps = ({ bookings }) => {
    return { cardList: bookings.cardList, cardLoader: bookings.cardLoader };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(
    withCustomTheme(withUser(injectIntl(withRouter(CardList))))
);



// WEBPACK FOOTER //
// ./src/components/Customer/CardList.jsx